import { LineItemPendingApprovalReason } from '~/types/api.model';
import { LineItemType } from './model';
export function isAdHocCharge(lineItem) {
    return lineItem.source === LineItemType.AdHocCharge;
}
export function isManual(lineItem) {
    return lineItem.source === LineItemType.Manual;
}
export function isCredit(lineItem) {
    return lineItem.source === LineItemType.Credit;
}
export function matchLineItem(lineItem, visitor) {
    switch(lineItem.source){
        case LineItemType.Automatic:
            return visitor.automatic(lineItem);
        case LineItemType.Manual:
            return visitor.manual(lineItem);
        case LineItemType.AdHocCharge:
            return visitor.adHocCharge(lineItem);
        case LineItemType.Credit:
            return visitor.credit(lineItem);
    }
}
const nothing = ()=>undefined;
const bundledSubLineItems = (lineItem)=>{
    var _lineItem_subLineItems;
    return (_lineItem_subLineItems = lineItem.subLineItems) !== null && _lineItem_subLineItems !== void 0 ? _lineItem_subLineItems : [];
};
const noSubLineItems = ()=>[];
export function subLineItems(lineItem) {
    return matchLineItem(lineItem, {
        automatic: bundledSubLineItems,
        manual: bundledSubLineItems,
        adHocCharge: noSubLineItems,
        credit: noSubLineItems
    });
}
const qboIntegrations = (lineItem)=>{
    var _lineItem_integrations;
    return (_lineItem_integrations = lineItem.integrations) !== null && _lineItem_integrations !== void 0 ? _lineItem_integrations : [];
};
const noIntegrations = ()=>[];
export function integrations(lineItem) {
    return matchLineItem(lineItem, {
        automatic: qboIntegrations,
        manual: qboIntegrations,
        adHocCharge: noIntegrations,
        credit: noIntegrations
    });
}
export function wasTaxed(lineItem) {
    return [
        lineItem,
        ...subLineItems(lineItem)
    ].some((param)=>{
        let { taxStatus } = param;
        return taxStatus.type === 'taxedAmount';
    });
}
export function billLaterCommandId(lineItem) {
    return isManual(lineItem) ? lineItem.manual.billLaterCommandId : undefined;
}
export function serviceId(lineItem) {
    return matchLineItem(lineItem, {
        automatic: (item)=>item.automatic.serviceId,
        manual: (item)=>item.manual.serviceId,
        adHocCharge: nothing,
        credit: nothing
    });
}
export function id(lineItem) {
    return lineItem.id;
}
export function quantity(lineItem) {
    return matchLineItem(lineItem, {
        automatic: nothing,
        manual: (item)=>item.manual.quantity,
        adHocCharge: (item)=>item.adHocCharge.quantity,
        credit: nothing
    });
}
export function discount(lineItem) {
    return matchLineItem(lineItem, {
        automatic: (item)=>item.automatic.discount,
        manual: (item)=>item.manual.discount,
        adHocCharge: (item)=>item.adHocCharge.discount,
        credit: nothing
    });
}
export function pendingApprovalReason(lineItem) {
    return matchLineItem(lineItem, {
        automatic: (item)=>item.automatic.pendingApprovalReason,
        manual: (item)=>item.manual.pendingApprovalReason,
        adHocCharge: (item)=>item.adHocCharge.pendingApprovalReason,
        credit: ()=>null
    });
}
export function isOverlappingPeriod(lineItem) {
    return pendingApprovalReason(lineItem) === LineItemPendingApprovalReason.OverlappingPeriod;
}
